// PrivacyTab — Gizlilik ayarlari (visibility toggles)
import { Eye, EyeOff, Globe, Lock } from 'lucide-react'
import { useState } from 'react'
import { API_URL, apiFetch } from '../../config/api'

interface PrivacySetting {
  key: string
  label: string
  description: string
  enabled: boolean
}

const DEFAULTS: PrivacySetting[] = [
  { key: 'profile_public', label: 'Public Profile', description: 'Anyone can view your profile', enabled: true },
  { key: 'show_email', label: 'Show Email', description: 'Display email on your profile', enabled: false },
  { key: 'show_activity', label: 'Show Activity', description: 'Others can see your activity feed', enabled: true },
  { key: 'show_agents', label: 'Show Agents', description: 'Your agents are visible to others', enabled: true },
  { key: 'show_xp', label: 'Show XP & Level', description: 'Display your level and XP publicly', enabled: true },
  { key: 'allow_messages', label: 'Allow Messages', description: 'Others can send you direct messages', enabled: true },
]

export default function PrivacyTab({ userId }: { userId: number }) {
  const [settings, setSettings] = useState<PrivacySetting[]>(DEFAULTS)
  const [saving, setSaving] = useState(false)

  const toggle = (key: string) => {
    setSettings(prev => prev.map(s => s.key === key ? { ...s, enabled: !s.enabled } : s))
  }

  const handleSave = async () => {
    setSaving(true)
    const payload = Object.fromEntries(settings.map(s => [s.key, s.enabled]))
    try {
      await apiFetch(`${API_URL}/api/profile/privacy`, { method: 'PUT', body: JSON.stringify(payload) })
    } catch { /* silent */ }
    setSaving(false)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <Lock size={16} color="#6366f1" />
        <span style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)' }}>Privacy Settings</span>
      </div>

      {settings.map(s => (
        <div key={s.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', borderRadius: 10, background: 'var(--body-bg)', border: '1px solid var(--border-color)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {s.enabled ? <Globe size={15} color="#10b981" /> : <EyeOff size={15} color="var(--text-secondary)" />}
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>{s.label}</div>
              <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{s.description}</div>
            </div>
          </div>
          <button onClick={() => toggle(s.key)} style={{ width: 42, height: 24, borderRadius: 12, border: 'none', background: s.enabled ? '#667eea' : 'var(--border-color)', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}>
            <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#fff', position: 'absolute', top: 3, left: s.enabled ? 21 : 3, transition: 'left 0.2s' }} />
          </button>
        </div>
      ))}

      <button onClick={() => { void handleSave() }} disabled={saving} style={{ marginTop: 12, alignSelf: 'flex-end', padding: '8px 20px', borderRadius: 8, background: '#667eea', border: 'none', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: saving ? 0.6 : 1 }}>
        {saving ? 'Saving...' : 'Save Privacy Settings'}
      </button>
    </div>
  )
}
